<template>
  <el-dialog title="批量录入" :visible="visible" @close="handleClose" class="import-students-dialog" :close-on-click-modal="false">
    <el-input
      type="textarea"
      :rows="10"
      placeholder="请输入学生名单（可直接粘贴微信接龙的形式），每行一个或多个学生，支持带干扰字符。
录入的名单将在本页面批量标记为已完成"
      v-model="internalText"
      style="width: 100%;">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>


export default {
  name: 'MobileImportStudentsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    students: {
      type: Array,
      default: () => []
    },
    currentDate: {
      type: String,
      default: ''
    },
    selectedType: {
      type: Number,
      default: 1
    },
    correctionRecords: {
      type: Array,
      default: () => []
    },
    isAssigned: {
      type: Boolean,
      default: true
    },
    classId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      internalText: ''
    };
  },
  computed: {
    confirmButtonText() {
      return this.isAssigned ? '确 定' : '确定并布置'
    }
  },
  watch: {
    // 监听外部传入的 text prop，同步到内部状态
    text: {
      handler(newVal) {
        this.internalText = newVal;
      },
      immediate: true
    },
    // 监听外部传入的 visible prop，打开弹窗时清空文本框
    visible: {
      handler(newVal) {
        if (newVal) {
          // 弹窗打开时清空内部文本，避免之前的内容残留
          this.internalText = '';
        }
      }
    }
  },
  methods: {
    handleClose() {
      // 弹窗关闭时不需要清空内容，保持内容供下次打开时参考
      this.$emit('update:visible', false);
    },
    handleCancel() {
      // 取消时不需要清空内容，保持内容供下次打开时参考
      this.$emit('update:visible', false);
    },
    handleConfirm() {
      // 点击确定时，直接处理批量录入逻辑
      this.$emit('update:text', this.internalText);
      this.processImportStudents();
    },
    
    // 处理批量录入的学生名单
    processImportStudents() {
      if (!this.internalText.trim()) {
        this.$message({
          type: 'warning',
          message: '请输入学生名单'
        });
        return;
      }
      
      const requestData = {
        inputText: this.internalText,
        date: this.currentDate,
        homeworkTypeId: this.selectedType,
        classId: this.classId
      };
      
      this.$http.post('/correctionRecords/batch-import', requestData)
        .then(response => {
          const { matchedCount, unmatchedLines, autoAssigned } = response.data.data;
          
          // 显示未匹配的行
          if (unmatchedLines && unmatchedLines.length > 0) {
            this.$emit('show-unmatched', unmatchedLines.join('\n'));
          }
          
          // 关闭弹窗
          this.$emit('update:visible', false);
          
          // 通知父组件刷新数据
          this.$emit('loadData');
          
          // 显示成功提示
          let message = `成功匹配并标记${matchedCount}名学生为已完成`;
          if (autoAssigned) {
            message += '，并自动布置了作业';
          }
          this.$message({
            type: 'success',
            message: message
          });
        })
        .catch(error => {
          console.error('批量录入失败:', error);
          this.$message.error('批量录入失败: ' + (error.response?.data?.message || error.message));
        });
    }
  }
};
</script>

<style scoped>
/* 批量录入弹窗样式 */
.import-students-dialog ::v-deep .el-dialog {
  margin: 54px 10px 10px 10px !important;
  width: calc(100% - 20px) !important;
}

/* 弹窗主体内边距 */
.import-students-dialog ::v-deep .el-dialog__body {
  padding: 15px !important;
}

/* 弹窗头部样式 */
.import-students-dialog ::v-deep .el-dialog__header {
  padding: 15px 20px !important;
  position: relative;
}

.import-students-dialog ::v-deep .el-dialog__headerbtn {
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
}

/* 对话框底部按钮样式 */
.dialog-footer ::v-deep .el-button {
  border-radius: 10px !important; /* 底部按钮圆角与规范一致 */
}

/* 允许在弹窗中的输入框选择文字 */
.import-students-dialog ::v-deep .el-dialog .el-input__inner {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.import-students-dialog ::v-deep .el-dialog .el-textarea__inner {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  white-space: pre-line;
}
</style>